import { fg } from '@atlassian/jira-feature-gating';

const JsmIncidentCommandCenterIncidentSummaryRelayProvider = {
	get(): boolean {
		return fg('jsm_incident_command_center_incident_summary');
	},
};

export default JsmIncidentCommandCenterIncidentSummaryRelayProvider;
